import React, {useEffect, useState} from "react";
import * as Body from './Styles'

import * as ConfigModals from '../config/modals/Modals'

import {Button} from "../../components/Button/Styles";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { State } from "../../utils/redux/store";
import disconnectedIcon from '../../assets/icons/disconnected.svg'

import * as Modals from './modals/Modals'
import AutotuningModal from './modals/AutotuningModal'
import CorrelationDrawer from './CorrelationDrawer'
import SensorBadge from '../../components/SensorBadge/SensorBadge'
import { SlidersHorizontal, AlertTriangle, Globe, GlobeOff, Plug, Unplug, SlidersVertical, House, PauseCircle } from 'lucide-react'
import * as functions from '../../utils/functions/functions'

import warningIcon from '../../assets/icons/warning-icon.svg'
import checkIcon from '../../assets/icons/check-icon.svg'
import bellIconInactive from '../../assets/icons/bell-icon.svg'
import homeIconInactive from '../../assets/icons/home-icon.svg'
import bellIconActive from '../../assets/icons/bell-icon-active.svg'
import homeIconActive from '../../assets/icons/home-icon-active.svg'
import bombaIcon from '../../assets/icons/bomba-icon.svg'
import transmissorIcon from '../../assets/icons/transmissor-icon.svg'
import valvulaIcon from '../../assets/icons/valvula-icon.svg'
import oleoIcon from '../../assets/icons/oleo-icon.svg'
import api from "../../utils/axiosInstance";
import * as Types from '../../utils/redux/types'
import { isSensorInvalido, getSensorLabel, THRESHOLDS_MANUTENCAO as TH } from '../../utils/alarmConfig'
import { USE_MOCK } from '../../utils/mock/mockFlag'
import Loading from "../../components/Loading/Loading";
import { dataMoenda } from "../../utils/redux/data";
import { getApiBaseUrl } from "../../utils/defines/apiUrl";
import { useIsMobile } from "../../utils/hooks/useIsMobile";
import { AutoProgressBar } from "../../components/AutoProgressBar/AutoProgressBar";

type TernosProps = {
    terno_id: number,
    nome_terno: string
}

const Status = {
    OK: 1,
    WARNING: 2,
}

const initialData: Types.MoendaState = {
    desempenho: 0,
    ternos: dataMoenda[0].ternos,
    nivel_acesso: 1,
    intervencao: 2,
    nome_usina: '',
    nuvem_status: USE_MOCK ? 2 : 1,
    clp_status: 1,
    ativo: true,
    ultimo_envio: USE_MOCK ? Date.now() - 2 * 3_600_000 : Date.now(),
    moendaParada: false,
    unidadeHidraulica: {
        status: 1,
        manual: false,
        oleo: {
            temperatura: USE_MOCK ? -222 : 26,   // mock: sentinel SENSOR_FALHA para testar badge
            trans_fil_suj_1: 1,
            trans_fil_suj_2: 0,
            trans_umidade: USE_MOCK ? -333 : 0,  // mock: sentinel SENSOR_ERRO para testar badge
            alarme_conjunto_filtro_1: 1,
            alarme_conjunto_filtro_2: 0,
            situacao: 0
        },
        bomba: {
            transmissor_pressao_2: 0,
            transmissor_pressao_1: 0,
            transmissor_pressao_3: 0,
            data: '',
            situacao: 0,
            autoteste_bomba_1: 0,
            autoteste_bomba_2: 0,
            autoteste_bomba_3: 0,
            pressao_max: 0
        },
        valvulas: [],
        transmissores: []
    }

}

const SituacaoBomba = {
    OK: 0,
    PROBLEMA_BOMBA_1: 1,
    PROBLEMA_BOMBA_2: 2,
    PROBLEMA_BOMBA_1_E_2: 3,
    PROBLEMA_BOMBA_3: 4,
    PROBLEMA_TRES_BOMBAS: 5,
    PROBLEMA_BOMBA_1_E_3: 6,
    PROBLEMA_BOMBA_2_E_3: 7
}

const Moenda = () => {
    const navigate = useNavigate()
    const isMobile = useIsMobile()


    const [params] = useSearchParams()
    const token = params.get('token')
    const nome_usina = params.get('nome-usina')
    const [loading, toggleLoading] = useState(true)
    
    const dispatch = useDispatch()
    const [data, setData] = useState<Types.MoendaState>(initialData)
    // true quando a última requisição falhou por falta de conexão (sem error.response, ex: sem
    // internet) — nesse caso não há como inferir o status real do CLP/nuvem, então omitimos os
    // indicadores em vez de continuar mostrando o último status conhecido (que pode estar errado).
    const [semConexao, setSemConexao] = useState(!navigator.onLine)

    const [bellIcon, toggleBell] = useState(bellIconInactive)
    const [homeIcon, toggleHome] = useState(homeIconInactive)
    const [modalAutotuning, toggleModalAutotuning] = useState(false)
    const [showCorrelation, setShowCorrelation] = useState(false)

    const [hasNotification, toggleHasNotification] = useState(false)

    const [modalNotifications, toggleModalNotifications] = useState(false)
    const [modalRegisterIntervention, toggleModalRegisterIntervention] = useState(false)
    const [modalInterventions, toggleModalInterventions] = useState(false)
    const [modalPerformance, togglePerformance] = useState(false)
    const [modalParametrizationPT, toggleModalParametrizationPT] = useState(false)
    const [modalParametrizationUH, toggleModalParametrizationUH] = useState(false)
    const [modalParametrizationUH2, toggleModalParametrizationUH2] = useState(false)
    const [modalLimits, toggleModalLimits] = useState(false)
    const [changeUser, toggleChangeUser] = useState(false)
    const [registerUser, toggleRegisterUser] = useState(false)
    const [isUH2, toggleIsUH2] = useState(false)

    const [openBomb,toggleOpenBomb] = useState(false)
    const [openOil, toggleOpenOil] = useState(false)
    const [openValve, toggleOpenValve] = useState(false)
    const [openTransmitter, toggleOpenTransmitter] = useState(false)
    
    const [ternoId, setTernoId] = useState<number>(0)
    const [terno, setTerno] = useState<Types.Terno>()
    const [ternos, setTernos] = useState<TernosProps[]>()
    const [visualizeTerno, toggleVisualizeTerno] = useState(false)
    const [nivelamentoLoading, setNivelamentoLoading] = useState(false)

    const [expandUHTitle, toggleUHTitle] = useState(false)

    // O navegador pode reportar "online" mesmo sem internet real (ex: só conectado à LAN) — por
    // isso esse listener é um sinal complementar, não substitui a detecção via falha de request.
    useEffect(() => {
        const updateConn = () => setSemConexao(!navigator.onLine)
        window.addEventListener('online', updateConn)
        window.addEventListener('offline', updateConn)
        return () => {
            window.removeEventListener('online', updateConn)
            window.removeEventListener('offline', updateConn)
        }
    }, [])

    const fetchMoenda = async () => {
        if (USE_MOCK) {
            toggleLoading(false)
            return
        }
        try {
            const response = await api.get(`${getApiBaseUrl()}/moenda` + '?token='+functions.ReplaceSpecialCharacters(token!), {withCredentials: true})
            setData(response.data)
            setSemConexao(false)
            toggleLoading(false)
            response.data.unidadeHidraulica2?toggleIsUH2(true):toggleIsUH2(false)
        } catch (error: any) {
            toggleLoading(false)
            if (!error.response) { setSemConexao(true); return }
            setSemConexao(false)
            functions.ResolveErrors(error.response.status, error.response.data.code, error.response.data.message, navigate, dispatch, error.response.data.content)
        }
    }

    useEffect(() => {
        fetchMoenda()
    }, [])

    const selectTernoById = (id: number, hasTernos?: {terno_id: number, nome_terno: string}[]) => {
        let ternoSelected = data.ternos.find(item => item.terno_id === id)
        if(!ternoSelected){
            dispatch({type: 'ADD_NOTIFICATION', status: 3, title: 'Terno não encontrado'})
            return
        }
        setTerno(ternoSelected)
        if(hasTernos)setTernos(hasTernos)
        toggleVisualizeTerno(true)

        // Indicador de % nivelado em Automático x Manual — calculado sob demanda (janela de 7
        // dias), não faz parte do polling principal da moenda.
        if (!USE_MOCK) {
            setNivelamentoLoading(true)
            api.get(`${getApiBaseUrl()}/terno?token=${functions.ReplaceSpecialCharacters(token!)}&ternoID=${id}`, {withCredentials: true})
                .then(response => {
                    setTerno(prev => prev ? {
                        ...prev,
                        percentual_automatico_nivelado: response.data.percentual_automatico_nivelado,
                        percentual_manual_nivelado: response.data.percentual_manual_nivelado
                    } : prev)
                })
                .catch(() => {})
                .finally(() => setNivelamentoLoading(false))
        }
    }

    const getTextBomb = (value: number) => {
        switch(value){
            case SituacaoBomba.OK:
                return "Bombas em funcionamento"
            case SituacaoBomba.PROBLEMA_BOMBA_1:
                return "Bomba 1 parada"
            case SituacaoBomba.PROBLEMA_BOMBA_2:
                return "Bomba 2 parada"
            case SituacaoBomba.PROBLEMA_BOMBA_3:
                return "Bomba 3 parada"
            case SituacaoBomba.PROBLEMA_BOMBA_1_E_2:
                return "Bombas 1 e 2 paradas"
            case SituacaoBomba.PROBLEMA_BOMBA_1_E_3:
                return "Bombas 1 e 3 paradas"   
            case SituacaoBomba.PROBLEMA_BOMBA_2_E_3:
                return "Bombas 2 e 3 paradas" 
            case SituacaoBomba.PROBLEMA_TRES_BOMBAS:
                return "Bombas 1, 2 e 3 paradas" 
            default:
                return "Erro ao encontrar status"
        }
    }

    const getAlertsOil = (UH: Types.UnidadeHidraulicaType) => {
        const vet: string[] = []

        if (isSensorInvalido(UH.oleo.temperatura)) {
            vet.push(`Temperatura do óleo: ${getSensorLabel(UH.oleo.temperatura)}.`)
        } else if (UH.oleo.temperatura >= TH.temperatura.critico) {
            vet.push('Temperatura acima da máxima. Bombas bloqueadas para impedir danos ao sistema.')
        } else if (UH.oleo.temperatura >= TH.temperatura.atencao) {
            vet.push('Temperatura próxima da máxima. Verificar funcionamento do trocador de óleo.')
        }

        const tempOk = !isSensorInvalido(UH.oleo.temperatura) && UH.oleo.temperatura > 25

        if (isSensorInvalido(UH.oleo.trans_fil_suj_1)) {
            vet.push(`Filtro 1: ${getSensorLabel(UH.oleo.trans_fil_suj_1)}.`)
        } else if (tempOk && UH.oleo.trans_fil_suj_1 >= TH.filtro.critico) {
            vet.push('Nível de saturação do filtro 1 em nível crítico.')
        } else if (tempOk && UH.oleo.trans_fil_suj_1 >= TH.filtro.atencao) {
            vet.push('Nível de saturação do filtro 1 próximo ao limite. Programar troca.')
        }

        if (UH.oleo.trans_fil_suj_2 !== null) {
            if (isSensorInvalido(UH.oleo.trans_fil_suj_2)) {
                vet.push(`Filtro 2: ${getSensorLabel(UH.oleo.trans_fil_suj_2)}.`)
            } else if (tempOk && UH.oleo.trans_fil_suj_2 >= TH.filtro.critico) {
                vet.push('Nível de saturação do filtro 2 em nível crítico.')
            } else if (tempOk && UH.oleo.trans_fil_suj_2 >= TH.filtro.atencao) {
                vet.push('Nível de saturação do filtro 2 próximo ao limite. Programar troca.')
            }
        }

        if (isSensorInvalido(UH.oleo.trans_umidade)) {
            vet.push(`Umidade do óleo: ${getSensorLabel(UH.oleo.trans_umidade)}.`)
        } else if (UH.oleo.trans_umidade > 200) {
            vet.push('Falha na leitura do transmissor de umidade.')
        } else if (UH.oleo.trans_umidade > TH.umidade.critico) {
            vet.push('Umidade em nível crítico. Providenciar imediatamente a remoção do excesso de umidade.')
        } else if (UH.oleo.trans_umidade > TH.umidade.atencao) {
            vet.push('Nível de umidade em estado de atenção. Providenciar remoção de excesso de umidade.')
        }

        if (UH.oleo.alarme_conjunto_filtro_1 === 2) vet.push('Possível problema no conjunto do filtro 1.')
        if (UH.oleo.alarme_conjunto_filtro_2 === 2) vet.push('Possível problema no conjunto do filtro 2.')

        return <>
            {vet.length > 0 ? <>
                <Body.MoendaTitle style={{marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <AlertTriangle size={16} color="#E5D34A" strokeWidth={2} />Alertas
                </Body.MoendaTitle>
                {vet.map((item, index) => (
                    <Body.MoendaText key={index.toString()}>● {item}</Body.MoendaText>
                ))}
            </> : null}
        </>
    }

    // ── Severidade das luzes de fundo e dos cards de manutenção ──────────
    // Derivada inteiramente do estado já existente (sem novo fetch/estado).

    const getDesempenhoSeverity = (d: Types.MoendaState): 'ok' | 'atencao' | 'critico' => {
        const colors = [
            functions.getStatusUH(d.unidadeHidraulica.status)?.color,
            ...d.ternos.map(t => functions.getStatusTerno(t.status).color),
        ]
        if (colors.includes('#F03F3F')) return 'critico'
        if (colors.includes('#E5D34A')) return 'atencao'
        return 'ok'
    }

    const getOleoSeverity = (UH: Types.UnidadeHidraulicaType): 'ok' | 'atencao' | 'critico' => {
        const tempOk = !isSensorInvalido(UH.oleo.temperatura) && UH.oleo.temperatura > 25

        if (!isSensorInvalido(UH.oleo.temperatura) && UH.oleo.temperatura >= TH.temperatura.critico) return 'critico'
        if (!isSensorInvalido(UH.oleo.trans_umidade) && UH.oleo.trans_umidade > TH.umidade.critico) return 'critico'
        if (tempOk && UH.oleo.trans_fil_suj_1 >= TH.filtro.critico) return 'critico'
        if (tempOk && UH.oleo.trans_fil_suj_2 !== null && UH.oleo.trans_fil_suj_2 >= TH.filtro.critico) return 'critico'

        if ([UH.oleo.temperatura, UH.oleo.trans_umidade, UH.oleo.trans_fil_suj_1, UH.oleo.trans_fil_suj_2]
            .filter((v): v is number => v !== null).some(isSensorInvalido)) return 'atencao'
        if (!isSensorInvalido(UH.oleo.temperatura) && UH.oleo.temperatura >= TH.temperatura.atencao) return 'atencao'
        if (!isSensorInvalido(UH.oleo.trans_umidade) && UH.oleo.trans_umidade > TH.umidade.atencao) return 'atencao'
        if (tempOk && UH.oleo.trans_fil_suj_1 >= TH.filtro.atencao) return 'atencao'
        if (tempOk && UH.oleo.trans_fil_suj_2 !== null && UH.oleo.trans_fil_suj_2 >= TH.filtro.atencao) return 'atencao'
        if (UH.oleo.alarme_conjunto_filtro_1 === 2 || UH.oleo.alarme_conjunto_filtro_2 === 2) return 'atencao'

        return 'ok'
    }

    const getManutencaoSeverity = (d: Types.MoendaState): 'ok' | 'atencao' | 'critico' => {
        const UH = d.unidadeHidraulica
        const oleo = getOleoSeverity(UH)
        if (oleo === 'critico') return 'critico'

        const atencao = oleo === 'atencao'
            || UH.bomba.situacao !== SituacaoBomba.OK
            || (UH.transmissores?.length ?? 0) > 0
            || (UH.valvulas?.length ?? 0) > 0
        return atencao ? 'atencao' : 'ok'
    }

    const getTernos = (array: {terno_id: number, nome_terno: string}[]) => {
        return <div style={{width: '100%', display: "flex", flexWrap: 'wrap', justifyContent: "space-between"}}>
            {array.map((item, index) => {
            return <Button key={index.toString()} style={{width: "49%", marginBottom: '10px'}}
                    onClick={()=>selectTernoById(item.terno_id, array)}>
                {item.nome_terno}
            </Button>})}
        </div>
    }

    const getConnectionBanner = () => {
        if (semConexao) return null
        if (data.nuvem_status !== 2) return null
        // ultimo_envio às vezes vem como string numérica da API (campo BIGINT no banco) — new Date(string)
        // não faz coerção numérica como o operador `-` faz, e cai silenciosamente em Invalid Date.
        const ultimoEnvioMs = Number(data.ultimo_envio)
        const ultimo = new Date(ultimoEnvioMs)
        const ultimoValido = !isNaN(ultimo.getTime())

        let msg: string
        let label = ''
        if (!ultimoValido) {
            msg = 'Sem registro de envio de dados para esta usina ainda.'
        } else {
            const horas = (Date.now() - ultimoEnvioMs) / 3_600_000
            const utcOffset = -ultimo.getTimezoneOffset() / 60
            const utcLabel = utcOffset >= 0 ? `UTC+${utcOffset}` : `UTC${utcOffset}`
            label = `Último envio: ${ultimo.toLocaleDateString('pt-BR')} às ${ultimo.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}h (${utcLabel})`

            if (data.clp_status === 2)
                msg = 'Falha de comunicação entre o Obsidian e o CLP. Os dados não estão sendo registrados nesse período. Exibindo valores salvos no último envio.'
            else if (horas < 4)
                msg = 'Queda de conexão recente. Se o Obsidian reconectar ao CLP, os dados desse período não serão perdidos. Exibindo valores salvos no último envio.'
            else
                msg = `Sem conexão há ${Math.floor(horas)}h. Verifique se o Obsidian está corretamente ligado na usina. Exibindo valores salvos no último envio.`
        }

        return (
            <Body.ConnectionBanner>
                <AlertTriangle size={14} color="#E5D34A" strokeWidth={2} style={{ flexShrink: 0 }} />
                <span>{msg}</span>
                {label && <span style={{ marginLeft: 'auto', opacity: 0.6, whiteSpace: 'nowrap' }}>{label}</span>}
            </Body.ConnectionBanner>
        )
    }

    // Sem conexão: não há como saber se a moenda está realmente parada (dado pode estar
    // desatualizado) — a falha de conexão tem prioridade sobre este aviso.
    const getMoendaParadaBanner = () => {
        if (semConexao) return null
        if (data.nuvem_status === 2) return null
        if (!data.moendaParada) return null

        return (
            <Body.MoendaParadaBanner>
                <PauseCircle size={14} color="rgba(255,255,255,0.6)" strokeWidth={2} style={{ flexShrink: 0 }} />
                <span>Moenda parada. Todas as bombas e ternos estão parados.</span>
            </Body.MoendaParadaBanner>
        )
    }

    // Sem conexão (falha de rede) — não há como inferir o status real do CLP/nuvem, então omite
    // os indicadores em vez de continuar mostrando o último status conhecido.
    const connPair = semConexao ? null : (
        <Body.ConnPair>
            <Body.ConnPill ok={data.nuvem_status !== 2}>
                {data.nuvem_status === 2 ? <GlobeOff size={12} /> : <Globe size={12} />}
                {data.nuvem_status === 2 ? 'Sem nuvem' : 'Online'}
            </Body.ConnPill>
            <Body.ConnPill ok={data.clp_status !== 2}>
                {data.clp_status === 2 ? <Unplug size={12} /> : <Plug size={12} />}
                {data.clp_status === 2 ? 'Falha CLP' : 'CLP ok'}
            </Body.ConnPill>
        </Body.ConnPair>
    )

    const navButtons = (
        <Body.NavButtons>
            <Button onClick={()=>toggleModalAutotuning(true)} title="Auto Tuning" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                <SlidersVertical size={20} color="rgba(255,255,255,0.7)" />
            </Button>
            <Button  onMouseEnter={()=>toggleHome(homeIconActive)} onMouseLeave={()=>toggleHome(homeIconInactive)}
                onClick={()=>navigate(-1)}>
                <House size={20} color="rgba(255,255,255,0.9)"/>
            </Button>
        </Body.NavButtons>
    )

    // Linhas com 2 GradientContent lado a lado — empilham no mobile
    const pairedRowStyle: React.CSSProperties = isMobile
        ? {flexDirection: 'column', gridGap: '10px 0px'}
        : {gridGap: '0px 10px'}

    const cardButtonsRowStyle: React.CSSProperties = isMobile
        ? {flexDirection: 'column', gridGap: '10px', width: '100%'}
        : {flexDirection: 'row', gridGap: '15px', width: '100%'}

    const cardButtonStyle: React.CSSProperties = isMobile
        ? {width: '100%', height: 40, whiteSpace: 'nowrap'}
        : {flex: 1, width: '100%', whiteSpace: 'nowrap'}

    const desempenhoCard = (
        <Body.Card>
            <Body.MoendaTitle style={{marginBottom: '15px', alignSelf: 'flex-start'}}>
                Desempenho
            </Body.MoendaTitle>
            <Body.Row style={{flexDirection: window.innerWidth <= 660? 'column':'row', width: '100%', marginBottom: '15px', justifyContent: 'space-around'}}>
                <Body.HalfContent percentage={45.9}>
                    <Body.TitleUHBG onMouseEnter={()=>toggleUHTitle(true)} onMouseLeave={()=>toggleUHTitle(false)}>
                        <Body.MoendaTitle style={{marginBottom: '0px', marginRight: '5px', fontSize: expandUHTitle?14:18}}>
                            Unidade Hidráulica
                        </Body.MoendaTitle>
                        <Body.CardTitle color="#FFF" style={{borderWidth: 1.5}} >
                                <Body.MoendaText style={{marginBottom: '0px', color: "#fff", fontWeight: 600,
                                    width: expandUHTitle?85:12, overflow: "hidden", textAlign: 'center'}}>
                                    {data.unidadeHidraulica.manual?"Manual":"Automática"}
                                </Body.MoendaText>
                    </Body.CardTitle>
                    </Body.TitleUHBG>
                    <Body.MoendaTitle style={{marginBottom: '5px', fontSize: 15,
                        fontWeight: 500, paddingLeft: '15px', paddingRight: '15px'}}>
                        {functions.getStatusUH(data.unidadeHidraulica.status)?.msg}
                    </Body.MoendaTitle>
                </Body.HalfContent>
                <Body.HalfContent percentage={45.9}>
                    <Body.TitleUHBG>
                        <Body.MoendaTitle style={{marginBottom: '0px'}}>Ternos</Body.MoendaTitle>
                    </Body.TitleUHBG>
                    <Body.Row style={{width: '100%', flexWrap: 'wrap', gridGap: '5px 5px', paddingLeft: '0px',
                        paddingRight: '15px', alignItems: 'center', justifyContent: 'center'}}>
                        {data.ternos.map((item, index)=>{
                            return <Body.CardTitle color="#17212E" key={index.toString()}
                                style={
                                    window.innerWidth >= 660?
                                        {height: '25px', width: 120, borderRadius: '12.5px', cursor: 'pointer',boxSizing: 'border-box',
                                            backgroundColor: "#17212E", paddingLeft: 10, paddingRight: 10 }:
                                        {height: '45px', width: 120, borderRadius: '12.5px', cursor: 'pointer',boxSizing: 'border-box',
                                            backgroundColor: "#17212E", paddingLeft: 10, paddingRight: 10 }}
                                 onClick={()=>selectTernoById(item.terno_id)}>
                                    <Body.MoendaText style={{marginBottom: '0px', color: "#fff", marginRight: '5px'}}>
                                        {item.nome_terno}
                                    </Body.MoendaText>
                                    {!item.funcionando?<Body.CircleTitle color={'#F03F3F'}
                                        style={{width: '14px', height: '14px', backgroundColor: '#F03F3F'}}  >
                                        <Body.MoendaText style={{marginBottom: '0px', fontSize: '12px', fontWeight: 700}}>P</Body.MoendaText>
                                    </Body.CircleTitle>:null}
                                    {item.funcionando && item.manual?<Body.CircleTitle color={'#FFF'}
                                        style={{width: '14px', height: '14px'}}  >
                                        <Body.MoendaText style={{marginBottom: '0px', fontSize: '12px', fontWeight: 700}}>M</Body.MoendaText>
                                    </Body.CircleTitle>:null}
                                    {item.funcionando && !item.manual?<Body.CircleTitle color={functions.getStatusTerno(item.status).color}
                                        style={{width: '14px', height: '14px'}}  >
                                        <Body.IconTitle style={{width: '8px', height: '8px'}} src={functions.getStatusTerno(item.status).icon} />
                                    </Body.CircleTitle>:null}
                                </Body.CardTitle>
                        })}
                    </Body.Row>
                </Body.HalfContent>
            </Body.Row>
            <Button onClick={()=>togglePerformance(true)}>
                Visualizar desempenho dos ternos
            </Button>
        </Body.Card>
    )

    const intervencoesCard = (
        <Body.Card style={{marginBottom: isMobile? 12:0}}>
            <Body.Row style={{width: '100%'}}>
                <Body.MoendaTitle style={{alignSelf: 'flex-start'}}>
                    Intervenções
                </Body.MoendaTitle>
            </Body.Row>
            <Body.NavButtons style={cardButtonsRowStyle}>
                <Button onClick={()=>toggleModalRegisterIntervention(true)}
                    style={cardButtonStyle}>
                    Cadastrar
                </Button>
                <Button onClick={()=>toggleModalInterventions(true)}
                    style={cardButtonStyle}>
                   {data.intervencao !== Status.OK && <AlertTriangle size={16} color="#E5D34A" strokeWidth={2} style={{marginRight: -4, verticalAlign: 'middle'}} />} Listar Intervenções
                </Button>
            </Body.NavButtons>
        </Body.Card>
    )

    const analiseCard = (
        <Body.Card>
            <Body.Row style={{width: '100%'}}>
                <Body.MoendaTitle style={{alignSelf: 'flex-start'}}>
                    Análise dos dados
                </Body.MoendaTitle>
            </Body.Row>
            <Body.NavButtons style={cardButtonsRowStyle}>
                <Button onClick={()=>{
                    // /graficos/variaveis monta categorias "Terno N" para todos os ternos cadastrados na
                    // usina (moenda.qtd_ternos), sem filtrar os que não têm o 4.0 instalado — só /moenda
                    // já faz esse filtro. Repassamos aqui os ternos realmente ativos (data.ternos já vem
                    // filtrado) para a Sidebar de Gráficos não oferecer botão de um terno inexistente.
                    const ternosAtivos = data.ternos.map(t => t.terno_id).join(',')
                    navigate("/charts?acess="+data.nivel_acesso+"&token="+token+"&ternos="+ternosAtivos+"&nome-usina="+encodeURIComponent(nome_usina ?? ''))
                }}
                    style={cardButtonStyle}>
                    Ver gráficos
                </Button>
                <Button onClick={()=>setShowCorrelation(true)}
                    style={cardButtonStyle}>
                    Análise de correlação
                </Button>
            </Body.NavButtons>
        </Body.Card>
    )

    const manutencaoCard = (
        <Body.Card style={{maxHeight: isMobile ? undefined : '100%'}}>
            <Body.MoendaTitle style={{alignSelf: 'flex-start'}}>
                Manutenção
            </Body.MoendaTitle>
            <Body.Scroll style={isMobile ? {height: 'auto', overflowY: 'visible'} : undefined}>
                <Body.MaintenanceCard severity={data.unidadeHidraulica.bomba.situacao === SituacaoBomba.OK ? 'ok' : 'atencao'}
                    style={{maxHeight: openBomb?"500px":"80px"}}
                    onClick={()=>toggleOpenBomb(old => !old)}>
                    <Body.MaintenanceInit>
                    <Body.Row style={{gridGap: '0px 10px'}}>
                        <Body.CircleTitle color={data?.unidadeHidraulica.bomba.situacao == SituacaoBomba.OK ? "#92B258":"#E5D34A"} >
                            <Body.IconTitle src={data?.unidadeHidraulica.bomba.situacao == SituacaoBomba.OK ? checkIcon:warningIcon} />
                        </Body.CircleTitle>
                        <Body.MaintenanceTitle>
                            Bombas
                        </Body.MaintenanceTitle>
                    </Body.Row>
                    <Body.MaintenanceCardIcon src={bombaIcon}/>
                    </Body.MaintenanceInit>
                    <Body.Row style={pairedRowStyle}>
                        <Body.GradientContent>
                            <Body.MoendaText>Transmissor de pressão 1</Body.MoendaText>
                            <Body.MoendaTitle>{data.unidadeHidraulica.bomba.transmissor_pressao_1.toFixed(0)} psi</Body.MoendaTitle>
                        </Body.GradientContent>
                        <Body.GradientContent>
                            <Body.MoendaText>Transmissor de pressão 2</Body.MoendaText>
                            <Body.MoendaTitle>{data.unidadeHidraulica.bomba.transmissor_pressao_2.toFixed(0)} psi</Body.MoendaTitle>
                    </Body.GradientContent>
                    </Body.Row>
                    <Body.Row style={{gridGap: '0px 10px'}}>
                        {data.unidadeHidraulica.bomba.transmissor_pressao_3?
                        <Body.GradientContent>
                            <Body.MoendaText>Transmissor de pressão 3</Body.MoendaText>
                            <Body.MoendaTitle>{data.unidadeHidraulica.bomba.transmissor_pressao_3.toFixed(0)} psi</Body.MoendaTitle>
                        </Body.GradientContent>:null}
                    </Body.Row>
                    <Body.Row style={pairedRowStyle}>
                        <Body.GradientContent>
                            <Body.MoendaText>Autoteste bomba 1</Body.MoendaText>
                            <Body.GradientAutoteste />
                            <Body.RailPickup>
                                <Body.Pickup
                                    left={functions.getAutotestePickup(data?.unidadeHidraulica.bomba.autoteste_bomba_1)}>
                                    <Body.CirclePickup />
                                    <Body.TextPickup>
                                        {data?.unidadeHidraulica.bomba.autoteste_bomba_1.toFixed(0)} psi
                                    </Body.TextPickup>
                                </Body.Pickup>
                            </Body.RailPickup>
                        </Body.GradientContent>
                        <Body.GradientContent>
                            <Body.MoendaText>Autoteste bomba 2</Body.MoendaText>
                            <Body.GradientAutoteste />
                            <Body.RailPickup>
                                <Body.Pickup
                                    left={functions.getAutotestePickup(data?.unidadeHidraulica.bomba.autoteste_bomba_2)}>
                                    <Body.CirclePickup />
                                    <Body.TextPickup>
                                        {data?.unidadeHidraulica.bomba.autoteste_bomba_2.toFixed(0)} psi
                                    </Body.TextPickup>
                                </Body.Pickup>
                            </Body.RailPickup>
                        </Body.GradientContent>
                    </Body.Row>
                    <Body.Row style={{gridGap: '0px 10px'}}>
                        {data?.unidadeHidraulica.bomba.autoteste_bomba_3?
                        <Body.GradientContent>
                            <Body.MoendaText>Autoteste bomba 3</Body.MoendaText>
                            <Body.GradientAutoteste />
                            <Body.RailPickup>
                                <Body.Pickup
                                    left={functions.getAutotestePickup(data?.unidadeHidraulica.bomba.autoteste_bomba_3)}>
                                    <Body.CirclePickup />
                                    <Body.TextPickup>
                                        {data?.unidadeHidraulica.bomba.autoteste_bomba_3.toFixed(0)} psi
                                    </Body.TextPickup>
                                </Body.Pickup>
                            </Body.RailPickup>
                        </Body.GradientContent>:null}
                    </Body.Row>
                    <Body.GradientContent>
                        <Body.MoendaText>
                            Situação
                        </Body.MoendaText>
                        <Body.Row >
                            <Body.MoendaTitle>
                                {getTextBomb(data!.unidadeHidraulica.bomba.situacao)}
                            </Body.MoendaTitle>
                        </Body.Row>
                    </Body.GradientContent>
                </Body.MaintenanceCard>

                <Body.MaintenanceCard severity={getOleoSeverity(data.unidadeHidraulica)}
                    style={{maxHeight: openOil?"700px":"80px"}}
                    onClick={()=>toggleOpenOil(old => !old)} >
                    <Body.MaintenanceInit>
                    <Body.Row style={{gridGap: '0px 10px'}}>
                        <Body.CircleTitle color={data?.unidadeHidraulica.oleo.situacao === Status.OK ? "#92B258":"#E5D34A"} >
                            <Body.IconTitle src={data?.unidadeHidraulica.oleo.situacao === Status.OK ? checkIcon:warningIcon} />
                        </Body.CircleTitle>
                        <Body.MaintenanceTitle>
                            Óleo
                        </Body.MaintenanceTitle>
                    </Body.Row>
                    <Body.MaintenanceCardIcon src={oleoIcon}/>
                    </Body.MaintenanceInit>
                    <Body.Row style={pairedRowStyle}>
                        <Body.GradientContent>
                            <Body.MoendaText>Temperatura</Body.MoendaText>
                            {isSensorInvalido(data.unidadeHidraulica.oleo.temperatura)
                                ? <SensorBadge label={getSensorLabel(data.unidadeHidraulica.oleo.temperatura)!} />
                                : <><Body.GradientUmidade />
                                  <Body.RailPickup>
                                    <Body.Pickup left={functions.getTemperaturePickup(data.unidadeHidraulica.oleo.temperatura)}>
                                        <Body.CirclePickup />
                                        <Body.TextPickup>
                                            {data.unidadeHidraulica.oleo.temperatura.toFixed(1)} ºC
                                        </Body.TextPickup>
                                    </Body.Pickup>
                                  </Body.RailPickup></>
                            }
                        </Body.GradientContent>
                        <Body.GradientContent>
                            <Body.MoendaText>Transmissor de umidade</Body.MoendaText>
                            {isSensorInvalido(data.unidadeHidraulica.oleo.trans_umidade)
                                ? <SensorBadge label={getSensorLabel(data.unidadeHidraulica.oleo.trans_umidade)!} />
                                : <><Body.GradientUmidade />
                                  <Body.RailPickup>
                                    <Body.Pickup left={data.unidadeHidraulica.oleo.trans_umidade}>
                                        <Body.CirclePickup />
                                        <Body.TextPickup>
                                            {data.unidadeHidraulica.oleo.trans_umidade.toFixed(2)} %
                                        </Body.TextPickup>
                                    </Body.Pickup>
                                  </Body.RailPickup></>
                            }
                        </Body.GradientContent>
                    </Body.Row>
                    <Body.Row style={pairedRowStyle}>
                        <Body.GradientContent>
                            <Body.MoendaText style={{marginBottom: '2px'}}>Transmissor de filtro sujo 1</Body.MoendaText>
                            {isSensorInvalido(data.unidadeHidraulica.oleo.trans_fil_suj_1)
                                ? <SensorBadge label={getSensorLabel(data.unidadeHidraulica.oleo.trans_fil_suj_1)!} />
                                : <><Body.GradientUmidade />
                                  <Body.RailPickup>
                                    <Body.Pickup left={functions.getFiltroPickup(data.unidadeHidraulica.oleo.trans_fil_suj_1)}>
                                        <Body.CirclePickup />
                                        <Body.TextPickup>
                                            {data.unidadeHidraulica.oleo.trans_fil_suj_1.toFixed(2)} bar
                                        </Body.TextPickup>
                                    </Body.Pickup>
                                  </Body.RailPickup></>
                            }
                        </Body.GradientContent>
                        {data?.unidadeHidraulica.oleo.trans_fil_suj_2 ? <Body.GradientContent>
                            <Body.MoendaText style={{marginBottom: '2px'}}>Transmissor de filtro sujo 2</Body.MoendaText>
                            {isSensorInvalido(data.unidadeHidraulica.oleo.trans_fil_suj_2)
                                ? <SensorBadge label={getSensorLabel(data.unidadeHidraulica.oleo.trans_fil_suj_2)!} />
                                : <><Body.GradientUmidade />
                                  <Body.RailPickup>
                                    <Body.Pickup left={functions.getFiltroPickup(data.unidadeHidraulica.oleo.trans_fil_suj_2)}>
                                        <Body.CirclePickup />
                                        <Body.TextPickup>
                                            {data.unidadeHidraulica.oleo.trans_fil_suj_2.toFixed(2)} bar
                                        </Body.TextPickup>
                                    </Body.Pickup>
                                  </Body.RailPickup></>
                            }
                        </Body.GradientContent> : null}
                    </Body.Row>
                    {getAlertsOil(data.unidadeHidraulica)}
                </Body.MaintenanceCard>

                <Body.MaintenanceCard severity={(data!.unidadeHidraulica.transmissores?.length ?? 0) === 0 ? 'ok' : 'atencao'}
                    style={{maxHeight: openTransmitter?"500px":"80px"}}
                    onClick={()=>toggleOpenTransmitter(old => !old)} >
                    <Body.MaintenanceInit>
                    <Body.Row style={{gridGap: '0px 10px'}}>
                        <Body.CircleTitle color={data!.unidadeHidraulica.transmissores?.length === 0? "#92B258":"#E5D34A"} >
                            <Body.IconTitle src={data!.unidadeHidraulica.transmissores?.length === 0? checkIcon:warningIcon} />
                        </Body.CircleTitle>
                        <Body.MaintenanceTitle>
                            Transmissores
                        </Body.MaintenanceTitle>
                    </Body.Row>
                    <Body.MaintenanceCardIcon src={transmissorIcon}/>
                    </Body.MaintenanceInit>
                    {data!.unidadeHidraulica.transmissores && data!.unidadeHidraulica.transmissores?.length === 0?<Body.MoendaText style={{marginBottom: '30px'}}>
                        A manutenção de seus
                        transmissores está em dia
                    </Body.MoendaText>:
                    getTernos(data!.unidadeHidraulica.transmissores!)}
                </Body.MaintenanceCard>

                <Body.MaintenanceCard severity={(data?.unidadeHidraulica.valvulas?.length ?? 0) === 0 ? 'ok' : 'atencao'}
                    style={{maxHeight: openValve?"500px":"80px"}}
                    onClick={()=>toggleOpenValve(old => !old)}>
                    <Body.MaintenanceInit>
                    <Body.Row style={{gridGap: '0px 10px'}}>
                        <Body.CircleTitle color={data?.unidadeHidraulica.valvulas?.length === 0? "#92B258":"#E5D34A"} >
                            <Body.IconTitle src={data?.unidadeHidraulica.valvulas?.length === 0? checkIcon:warningIcon} />
                        </Body.CircleTitle>
                        <Body.MaintenanceTitle>
                            Válvulas
                        </Body.MaintenanceTitle>
                    </Body.Row>
                    <Body.MaintenanceCardIcon src={valvulaIcon}/>
                    </Body.MaintenanceInit>
                    {data?.unidadeHidraulica.valvulas && data?.unidadeHidraulica.valvulas?.length === 0?<Body.MoendaText style={{marginBottom: '30px'}}>
                        A manutenção de suas
                        válvulas está em dia
                    </Body.MoendaText>:
                    getTernos(data?.unidadeHidraulica.valvulas!)}
                </Body.MaintenanceCard>
            </Body.Scroll>
        </Body.Card>
    )

    return <Body.Container>
        <Body.BgLights>
            <Body.BlobFixedBlue />
            <Body.BlobDesempenho severity={getDesempenhoSeverity(data)} />
            <Body.BlobManutencao severity={getManutencaoSeverity(data)} />
        </Body.BgLights>
        <Body.Nav>
            {isMobile ? (
                <Body.NavMobileStack>
                    <Body.NavTitle>
                        {nome_usina}
                    </Body.NavTitle>
                    <Body.NavSecondRow>
                        {connPair}
                        {navButtons}
                    </Body.NavSecondRow>
                </Body.NavMobileStack>
            ) : (
                <>
                    <Body.NavTitleContent>
                        <Body.NavTitle>
                            {nome_usina}
                        </Body.NavTitle>
                    </Body.NavTitleContent>
                    <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                        {connPair}
                        {navButtons}
                    </div>
                </>
            )}
        </Body.Nav>

        {isMobile && (getConnectionBanner() || getMoendaParadaBanner())}

        <Body.Content style={isMobile ? {flexDirection: 'column', height: 'auto', maxHeight: 'none', minHeight: 0} : undefined}>
            {isMobile ? (
                <Body.HalfContent percentage={100} style={{display: 'flex', flexDirection: 'column', gridGap: '10px 0px', height: 'auto', overflowY: 'visible'}}>
                    <Body.CardGlowWrap>
                        <Body.BlobDesempenhoCard severity={getDesempenhoSeverity(data)} />
                        {desempenhoCard}
                    </Body.CardGlowWrap>
                    <Body.CardGlowWrap>
                        <Body.BlobManutencaoCard severity={getManutencaoSeverity(data)} />
                        {manutencaoCard}
                    </Body.CardGlowWrap>
                    {analiseCard}
                    {intervencoesCard}
                </Body.HalfContent>
            ) : (
                <>
                    <Body.HalfContent percentage={49.5} style={{display: 'flex', flexDirection: "column", gridGap: '10px 0px'}}>
                        {desempenhoCard}
                        {intervencoesCard}
                        {analiseCard}
                    </Body.HalfContent>
                    <Body.HalfContent percentage={49.5}>
                        {manutencaoCard}
                    </Body.HalfContent>
                </>
            )}
        </Body.Content>
        {registerUser?<ConfigModals.RegisterUser toggle={toggleRegisterUser} />:null}
        {changeUser?<ConfigModals.EditUsers toggleModal={toggleChangeUser} />:null}
        {/* {modalNotifications?<Modals.NotificationModal toggleModal={toggleModalNotifications} notificacoes={data!.notificacoes} />:null} */}
        {modalInterventions?<Modals.InterventionsModal toggleModal={toggleModalInterventions}
            token={token!} qtdTernos={data!.ternos.length}/>:null}
        {modalRegisterIntervention?<Modals.RegisterIntervention toggleModal={toggleModalRegisterIntervention}
            token={token!} qtdTernos={data!.ternos.length} />:null}
        {/* {modalParametrizationPT?<Modals.ParametrizationTernoModal toggleModal={toggleModalParametrizationPT}
            token={token!} terno={1}/>:
            null} */}
        {modalParametrizationUH?<Modals.ParametrizationUH toggleModal={toggleModalParametrizationUH} 
            token={token!} uh={1}/>:null}
        {modalParametrizationUH2?<Modals.ParametrizationUH toggleModal={toggleModalParametrizationUH2} 
            token={token!} uh={2}/>:null}
        {modalPerformance?<Modals.Performance toggleModal={togglePerformance} ternos={data!.ternos} />:null}
        {modalAutotuning?<AutotuningModal toggleModal={toggleModalAutotuning} token={token!} />:null}
        {visualizeTerno?<Modals.VisualizarTerno toggleModal={toggleVisualizeTerno}
            terno={terno!} nivelamentoLoading={nivelamentoLoading}/>:null}
        {modalLimits?<Modals.DefineLimits toggleModal={toggleModalLimits} ternos={data!.ternos} token={token!}
            id={ternoId} isUH2={isUH2} />:null}
        {loading?<Loading />:null}
        {showCorrelation?<CorrelationDrawer token={token!} onClose={()=>setShowCorrelation(false)} />:null}
        {!isMobile && (getConnectionBanner() || getMoendaParadaBanner())}
        {!isMobile && <AutoProgressBar onComplete={fetchMoenda} />}
    </Body.Container>
}

export default Moenda